import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import StatusList from "./StatusList";
import StatusForm from "./StatusForm";
import Navigation from "./Navigation";

export default function Status() {
  return (
    <div>
      <Navigation />
      <Routes>
        <Route path="" element={<Navigate to="list" replace />} />
        <Route path="list" element={<StatusList />} />
        <Route path="create" element={<StatusForm />} />
        <Route path="edit/:id" element={<StatusForm />} />
        <Route path="*" element={<div>Status page not found</div>} />
      </Routes>
    </div>
  );
}
